const CarouselUtils = {
  initVariantCarousel: function (carousel, options = {}) {
    const defaults = {
      swatchWidth: 48,
      gap: 7,
      visibleSwatches: 4,
      trackSelector: ".product-card__variants-track",
      prevBtnSelector: ".product-card__variant-arrow--prev",
      nextBtnSelector: ".product-card__variant-arrow--next",
    };

    const config = { ...defaults, ...options };
    const track = carousel.querySelector(config.trackSelector);
    const prevBtn = carousel.querySelector(config.prevBtnSelector);
    const nextBtn = carousel.querySelector(config.nextBtnSelector);

    if (!track) return;

    let currentPosition = 0;
    const swatchWidth = config.swatchWidth + config.gap;
    const totalVariants =
      parseInt(track.dataset.totalVariants) || track.children.length;
    const maxPosition = Math.max(0, totalVariants - config.visibleSwatches);

    const updatePosition = () => {
      const offset = -(currentPosition * swatchWidth);
      track.style.transform = `translateX(${offset}px)`;

      if (prevBtn) prevBtn.disabled = currentPosition === 0;
      if (nextBtn) nextBtn.disabled = currentPosition >= maxPosition;
    };

    if (prevBtn) {
      prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (currentPosition > 0) {
          currentPosition--;
          updatePosition();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (currentPosition < maxPosition) {
          currentPosition++;
          updatePosition();
        }
      });
    }

    updatePosition();
    return { currentPosition, updatePosition, totalVariants };
  },

  initAllVariantCarousels: function (
    selector = ".product-card__variants-carousel",
    options = {}
  ) {
    document.querySelectorAll(selector).forEach((carousel) => {
      this.initVariantCarousel(carousel, options);
    });
  },

  initColorSwatchEvents: function (container, selectors = {}) {
    const defaults = {
      swatchSelector: ".product-card__color-swatch",
      mainImageSelector: "[data-main-image]",
      carouselSelector: ".product-card__variants-carousel",
      activeClass: "product-card__color-swatch--active",
    };

    const config = { ...defaults, ...selectors };

    container.addEventListener(
      "mouseenter",
      (e) => {
        const swatch = e.target.closest(config.swatchSelector);
        if (!swatch) return;

        const cardId = swatch.dataset.cardId;
        const imageUrl = swatch.dataset.image;
        const card = document.querySelector(`[data-card-id="${cardId}"]`);

        if (card && imageUrl) {
          const mainImage = card.querySelector(config.mainImageSelector);
          if (mainImage) mainImage.src = imageUrl;
        }

        const carousel = swatch.closest(config.carouselSelector);
        if (carousel) {
          carousel
            .querySelectorAll(config.swatchSelector)
            .forEach((s) => s.classList.remove(config.activeClass));
          swatch.classList.add(config.activeClass);
        }
      },
      true
    );

    container.addEventListener(
      "mouseleave",
      (e) => {
        const swatch = e.target.closest(config.swatchSelector);
        if (!swatch) return;

        const cardId = swatch.dataset.cardId;
        const card = document.querySelector(`[data-card-id="${cardId}"]`);

        if (card) {
          const mainImage = card.querySelector(config.mainImageSelector);
          const defaultImage = mainImage?.dataset.defaultImage;

          if (mainImage && defaultImage) {
            mainImage.src = defaultImage;
          }

          const carousel = swatch.closest(config.carouselSelector);
          if (carousel) {
            const firstSwatch = carousel.querySelector(config.swatchSelector);
            carousel
              .querySelectorAll(config.swatchSelector)
              .forEach((s) => s.classList.remove(config.activeClass));
            firstSwatch?.classList.add(config.activeClass);
          }
        }
      },
      true
    );
  },

  debounce: function (func, wait = 250) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  getResponsiveItemsPerPage: function (breakpoints = {}) {
    const defaults = {
      mobile: { max: 768, items: 1 },
      tablet: { max: 1024, items: 2 },
      laptop: { max: 1280, items: 3 },
      desktop: { items: 4 },
    };

    const config = { ...defaults, ...breakpoints };
    const width = window.innerWidth;

    if (width <= config.mobile.max) return config.mobile.items;
    if (width <= config.tablet.max) return config.tablet.items;
    if (width <= config.laptop.max) return config.laptop.items;
    return config.desktop.items;
  },
};

if (typeof module !== "undefined" && module.exports) {
  module.exports = CarouselUtils;
}
